import React from 'react';
import { observer } from 'mobx-react';

import UpdateToolbarPlaceholder from 'components/shared/NotificationBar/UpdateToolbarPlaceholder';
import NoInternetPlaceholder from 'components/shared/NotificationBar/NoInternetPlaceholder';
import SystemOfflinePlaceholder from 'components/shared/NotificationBar/SystemOfflinePlaceholder';
import { useStore } from 'hooks';

const NotificationBar = () => {
  const { ui, hardwareStatusStore } = useStore();

  return (
    <>
      {(hardwareStatusStore.isOffline || hardwareStatusStore.isRestored) && (
        <SystemOfflinePlaceholder />
      )}
      {ui.isUpdatedAvailable && <UpdateToolbarPlaceholder />}
      {ui.isNoInternet && <NoInternetPlaceholder />}
    </>
  );
};

export default observer(NotificationBar);
